import { createSlice } from "@reduxjs/toolkit";
import storage from "../../services/storage";


const initialState = {
    subdomain: null,
    isMainSite: localStorage.getItem("xStoreId") !== null ? false : true,
    storeId: null,

};

export const domainSlice = createSlice({
    name: "domain",
    initialState,
    reducers: {
        setSubdomain: (state, action) => {

            const domain = action.payload;
            console.log('payload', domain.success);
            if (domain.success === true) {
                state.subdomain = domain?.subdomain || null;
                state.isMainSite = domain?.isMainSite;
                state.storeId = domain?.storeId || null;
                storage.store("xStoreId", domain?.storeId || null);
            }
        },
    },
});

export const { setSubdomain } = domainSlice.actions;
export default domainSlice.reducer;
